import { Observable } from 'rxjs';
import { ILanguage } from './language.interface';

export interface ITranslationInterface {
  getTranslations(languageISO: string): Observable<any>;
  getLanguages(): Observable<ILanguage[]>;
  getSelectedLanguage(): Observable<ILanguage>;
  pt(textId: string): string;
  getLanguage(languageISO: string): ILanguage;
  setLanguage(languageISO: string): void;
  getLanguagesByCountryCode(countryCode: string): ILanguage[];
}
